import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseDialogDirective } from '../../../../../shared/components/base/base-dialog.directive';
import {
  ButtonSize,
  ButtonStyle
} from '../../../../../shared/enums/button.enum';
import { ButtonComponent } from '../../../../../shared/components/button/button.component';
import { DialogWrapperComponent } from '../../../../../shared/components/wrappers/dialog-wrapper/dialog-wrapper.component';
import { TextareaComponent } from '../../../../../shared/components/controllers/textarea/textarea.component';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-checkout-notes-dialog',
  imports: [
    ButtonComponent,
    DialogWrapperComponent,
    TextareaComponent,
    FormsModule,
    ReactiveFormsModule
  ],
  templateUrl: './checkout-notes-dialog.component.html',
  styleUrl: './checkout-notes-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckoutNotesDialogComponent extends BaseDialogDirective<string> {
  protected readonly initialNote: string = this.dialogData?.note || '';
  protected readonly ButtonStyle = ButtonStyle;
  protected readonly ButtonSize = ButtonSize;

  noteControl: FormControl = new FormControl<string>(this.initialNote);
}
